import React from 'react';
const zh_CN_in_risks_page = {
  address: '地址',
  type: '类型',
};
const zh_CN = {
  view_account: '查看账户',
  liquidity: '流动性',
  tokens: '代币',
  fee: '手续费',
  fees: '手续费',
  details: '详情',
  detail: '详情',
  minimum_tokens_out: '最少可获得代币数量',
  pair: '交易对',
  tvl: '总锁定价值',
  add_liquidity: '添加流动性',
  remove_liquidity: '移除流动性',
  total_liquidity: '总流动性',
  my_shares: '份额',
  token: '代币',
  enter_token_address: '输入代币地址',
  remove: '移除',
  select: '选择代币',
  select_token: '选择代币',
  total_fee: '总费用 % ',
  start_at: '开始于',
  end_at: '结束于',
  ended: '已结束',
  pending: '未开始',
  rewards_per_week: '每周奖励总额',
  apr: '年化率',
  total_staked: '质押总金额',
  unclaimed_rewards: '未领取奖励',
  claim: '认领',
  claim_all: '认领全部',
  stake: '质押',
  unstake: '取消质押',
  your_shares: '份额',
  cancel: '取消',
  days: '天后',
  slippageCopyForMobile:
    '滑点是您期望得到的和因先执行的其他交易而实际得到的之间的差异。',
  slippageCopy:
    '滑点是您期望得到的和因先执行的其他交易而实际得到的之间的差异。',
  swapCopy:
    '兑换交易是将第一个选定的代币交换成第二个选定的代币。<br> 将使用最高流动性和最低交易费用的池。',
  addTokenCopy: '添加NEP-141代币。',
  farmRewardsCopy: '这是基于价格的指示性值而非实际结果',
  you_do_not_have_enough: '你没有足够的',
  is_not_exist: '不存在',
  must_input_a_value_greater_than_zero: '必须输入一个大于0的值',
  no_pool_available_to_make_a_swap_from: '没有池子能够提供',
  for_the_amount: '数额为',
  no_pool_eng_for_chinese: '的交易',
  is_not_a_valid_swap_amount: '错误的兑换数额',
  not_nep_address:
    '您输入的地址不是NEP-141地址，请检查后再输入。如果是其他主网合约，去彩虹桥进行桥接处理',
  not_correct_address: '您输入的地址不正确，请检查后再输入',
  pool_id: '流动池 ID',
  more_pools: '更多流动池',
  my_watchlist: '我的收藏',
  h24_volume: '24小时交易量',
  volume: '交易量',
  hide_low_tvl_pools: '隐藏低锁仓量池',
  hide_low_tvl_pools_mobile: '隐藏低锁仓量池',
  my_watchlist_copy: '收藏过的流动池将会出现在这里',
  language: '语言',
  deposit_to_add_liquidity: '\b存入代币以添加流动性',
  slip_warn: '注意，请检查您可以收到的最低金额',
  slip_invalid: '请输入有效的值',
  reward_tokens: '奖励币',
  detail_tip: '详情',
  no_data: '暂无数据',
  attention: '请注意',
  live: '进行中',
  ended_search: '已结束',
  my_farms: '你的农场',
  sort_by: '按排序',
  your_farms: '你的农场',
  new: '最新',
  unstake_tip_t: '你有未领取的奖励...',
  unstake_tip_m:
    '取消质押操作会把所有质押从相同交易对的所有进行中和未开始的农场里移除.',
  unstake_tip_b: '你想取消质押吗?',
  value_rewards: '已领取的奖励',
  stake_unstake_tip: '质押或取消质押操作将自动领取奖励',
  over_tip: '为了优化gas费用，您一次最多可以提取4个代币',
  no_token_tip: '没有可提取的代币',
  getToken_tip: '你可以现在认领你的奖励或质押代币！',
  in_farm: '在农场',
  price_impact: '价格影响',
  roi_calculator: 'ROI 计算器',
  lp_staked: '流动代币质押',
  usd: '美元',
  lp_token: '流动性代币',
  stake_for: '质押时间',
  day_1: '1天',
  day_2: '7天',
  day_3: '30天',
  day_4: '90天',
  cur_apr: 'ROI',
  reward_token: '奖励代币',
  get_lp_token: '获取流动性代币',
  calculate_roi: 'ROI 计算器',
  rewards_claimed: '可领取的奖励',
  value_rewards_token: '奖励代币的价值',
  all: '全选',
  all_5: '一次最多4种代币',
  more_than: '请输入大于等于0.01的数字',
  less_than: '请输入小于20的数字',
  no_valid: '请输入有效数字',
  lp_fee: '流动性提供者',
  referral_fee: '中介费',
  protocol_fee_referral_fee: '协议费和中介费',
  total_fee_create: '总费用',
  ref: 'REF',
  are_you_sure: '你确定吗',
  price_impact_is_about: '价格影响大约是',
  yes_swap: '确定, 兑换吧',
  input_greater_than_available_shares: '输入大于可用份额',
  auto_router: '交易路径',
  optimal_path_found_by_our_solution: '我们找到的最好路径',
  make_sure_you_understand_what_you_do: '请确认你此时所做的事',
  filter_by: '过滤',
  allOption: '全部',
  stablecoin: '稳定币',
  near_ecosystem: 'Near生态',
  bridged_tokens: '桥接代币',
  gaming: '游戏',
  nft: 'NFT',
  bridge: '桥接 到/来自',
  no_result: '抱歉, 没有找到农场',
  multiple: '倍率',
  default: '默认',
  create: '创建',
  select_a: '选择一个',
  wallet: '钱包',
  to_use_ref_finance: '来使用{appName}',
  not_supported: '不支持',
  installed: '已安装',
  installe_now: '现在安装',
  extension: '插件',
  first_time_using_ref: '第一次使用{appName}',
  learn_more: '查看更多',
  install_sender_now: '现在安装Sender',
  connect_to_dapps_with_one_click: '一键连接到dApp',
  install: '安装',
  Connecting: '连接中',
  check_sender_wallet_extension: '请确认Sender钱包插件',
  having_trouble: '有问题?',
  go_back: '返回',
  web: '网页',
  Type: '类型',
  click_to_view: '点击查看详情',
  transaction_failed: '交易失败',
  wallet_vi: ' ',
  value: '价值',
  usd_value: '美元价值',
  initialize_account_tip: '请初始化你的账号',
  support_ledger_tip:
    '根据Ledger的设计, 因其内存限制, Ledger不能处理大型交易(即自动路由: 一次跨多个池进行交易)。激活后,"支持 Ledger"选项会将交易限制在最简单的形式(不利于更好的价格),因此可以签署合理规模的交易。',
  start: '开始',
  max: 'Max',
  ref_account_balance_tip: '添加/移除流动性的时候似乎发生了错误',
  ref_account_tip_2: '你的REF账户中有代币',
  ref_account_tip_top: '你的代币可能在REF内部账户里',
  click_here: '点击这里',
  to_recover_them: '来取回他们',
  ref_account_tip_3: '要从您的REF帐户提取代币到您的NEAR钱包,请选择并提取',
  aurora_account_tip_4: '要从您的映射帐户提取代币到您的NEAR钱包,请选择并提取',
  buy: '买',
  sell: '卖',
  rate: '汇率',
  name: '名字',
  diff: '差距',
  best: '最好',
  awesomeNear_verified_token: 'AwesomeNear 已认证代币',
  pool_fee_apr: '流动池手续费年化收益率',
  ref_account_balance_tip_mobile: '你的REF账户中有代币.',
  click: '点击',
  to_recover: '来取回.',
  rewards_week: '奖励/周',
  rewards: '奖励',
  claimed_Rewards: '已领取奖励',
  POOL: '流动池',
  lp_Token: 'LP 代币',
  booster: '加速器',
  append: '追加',
  farm: '农场',
  status: '状态',
  Rewards: '奖励',
  free: '活期',
  lp_tokens: 'LP 代币',
  connect_to_wallet: '连接钱包',
  slash_policy_content:
    '每个种子都有自己的罚金倍率。 并且会随着时间线性递减，直到本CD账号解锁时为0。',
  not_expired: '没有过期',
  accept_pay_slash_tip: '我接受支付罚金',
  i_will_pay: '我将要支付',
  lp_token_slash: 'LP代币退出费。',
  expired: '已到期',
  all_4_v2: '4 代币/每次',
  more_than_seed: '输入必须大于或等于 ',
  how_to_earn_more: '如何赚更多?',
  lock_your_lp_tokens_with_booster: '锁定您的 LP 代币以获得更高的奖励',
  unstaked_anytime_no_booster: '随时取消，没有加速器',
  locking_stake: '锁定质押',
  change_to_lock: '更改为锁定质押',
  estimated_rewards: '预计回报',
  final_booster: 'Final Booster',
  existing_amount: '最终加速器',
  append_amount: '追加金额',
  will_be_able_to_unstaked_after: '后就可以解压',
  you_have: '你有',
  reward_apr: '奖励年化收益率',
  stake_min_deposit: '输入的值必须大于或等于 ',
  unlock: '解锁',
  exit_fee: '退出费',
  end_locking_period: '锁定期结束',
  add_lp_tokens_tip:
    '您需要 LP 代币来质押相应的农场。 首先，向池中添加流动性以获得 LP 代币。',
  slash_tip: '退出费用=退出费率*锁定期结束*解锁金额',
  nonBoosted: '非加速器',
  exit_fee_tip: '打破锁定期您将支付的估计金额',
  forbiddenTip: '此场不支持此持续时间选项',
  unstakeTip: '质押或取消质押将自动获得您的奖励。',
  endedFarmsUnstakeTip: '取消抵押将从同一对的所有活动和待定农场中删除抵押。 ',
  comimg: '即将开始',
  appendTip: '不能早于当前锁定时间',
  week: '周',
  yours: '你的',
  boost: '加速',
  near: 'NEAR',
  eth: 'ETH',
  others: '其它',
  stakeLove: '质押LOVE',
  unstakeLove: '解押LOVE',
  get_love: '获取LOVE',
  swap_successful: '交易成功. ',
  trading_successfull: '交易成功. ',
  available_to_stake: '可供质押',
  your_assets: '你的资产',
  connect_wallet: '连接钱包',
  disconnect: '断开连接',
  change: '切换钱包',
  connect: '连接',
  veTip: 'veLP代币不可转移, 代表你的投票治理能力 ',
  loveTip:
    'LOVE代表veToken的流动性, 就像NEP-141代币,可转移, 可交易, 可建立流动池, 可质押,可作为农场激励.代表veTokens的潜在流动性',
  keep_ve: '保持',
  months: '月',
  month: '月',
  lock_lp_tokens: '锁定流动性代币',
  get_lptoken: '获得流动性代币',
  duration: '期限',
  ve_lock_tip: '不能早于当前的解锁期',
  get: '获得',
  you_have_no_lp_share: '你没有流动性代币',
  lock: '锁定',
  locked: '已锁定',
  available: '可用',
  in: '在',
  filter: '过滤',
  options: '选项',
  ratio: '比例',
  back: '返回',
  confirm: '确认',
  total: '总计',
  type: '类型',
  connect_to_near_wallet: '连接NEAR钱包',
  v1Legacy: 'Legacy',
  v2New: 'Classic-New',
  v2_new_farms: '经典新版农场',
  migrate_now: '现在升级!',
  v2_boost_tip:
    '经典农场将支持加速农场。遗产农场将在<span class="font-bold">2022年8月1日</span>耗尽奖励。',
  v2_boost_no_tip:
    '遗产农场将在<span class="font-bold">2022年8月1日</span>耗尽奖励。',
  love: 'LOVE',
  Available_to_stake: '可供质押',
  you_staked: '你已质押',
  has_rewards_tip_in_v2:
    '从<a rel="noopener noreferrer nofollow" href="/farms" class="text-sm text-greenColor cursor-pointer underline hover:text-senderHot mr-1"> 遗产农场</a>中提取遗留奖励。',
  how_to_get: '如何获取?',
  get_booster: '获得加速器',
  ended_farms: '已结束农场',
  boosted_farms: '被加速的农场',
  your_farm: '你的农场',
  your_boosted_farms: '你的加速农场',
  search_farms_by_token: '通过代币搜索农场',
  search_farms: '搜索农场',
  more_lock_ve_popup2: ' ',
  left: '剩余',
  create_pool: '创建流动池',
  search_by_token: '根据代币搜索',
  your_power: '你的能量',
  farm_has_boost_tip: '你的能量 = 你的流动性代币 * 倍率 (根据质押的LOVE数量)',
  farm_no_boost_tip: '你的能量 = 你质押的流动性代币',
  more_than_a_simple_pool: '不只是一个简单的流动池',
  ended_Farms: '已结束的农场',
  vote_capital: '公投',
  boostFarmTip: '通过质押LOVE获得加速',
  boosted: '加速',
  love_staked: '已质押的LOVE',
  your_apr: '你的奖励年化收益率',
  range_apr: '范围和参考年化收益率',
  no_pair_found: '没有找到匹配的交易对',
  found_stable_pool_in_sauce: '在SAUCE中找到一个稳定池',
  lp_tokens_locking: 'LP代币',
  you_currently_have: '你现在有',
  scheduled_to_be_unlocked: '将可解锁于',
  locking_more_lp_tokens: '锁定更多LP代币',
  will_mean_these: '意味着',
  lp_tokens_will_not_be_unlocked_until: 'LP代币将不可被解锁直到',
  "I_understand_that_I_won't_be_able_to_remove_my": '我已了解我将不能解锁我的',
  until: '直到',
  add: '添加',
  finish: '完成',
  add_custom_network: '添加自定义网络',
  network_name: '网络名称',
  rpc_name_taken_tip: '网络名称已占用',
  network_invalid: '无效网络',
  fobidden_testnet_rpc_tip: 'RPC服务器的网络(测试网)与本网络(主网)不同',
  no_support_testnet_rpc_tip: 'Testnet不支持添加自定义RPC',
  stable: 'Stable',
  limit: '限价单',
  your_active_orders_will_appear_here: '你的当前订单在这里展示',
  your_history_orders_will_appear_here: '你的历史订单在这里展示',
  farm_only: '仅含农场',
  please_confirm_this_transaction_on_ledger: '请在Ledger上确认此次交易',
  limit_order: '限价单',
  farm_stop_tip: '这个农场已经停止。',
  pool_stop_tip: '这个流动池已经停止。',
  volume_24h: '24小时交易量',
  add_to_watchlist: '添加到收藏',
  remove_from_watchlist: '从收藏中移除',
  create_order: '创建限价单',
  filled: '已成交',
  canceled: '已取消',
  partially_filled: '部分成交',
  pool_composition: '流动池构成',
  amount: '数量',
  h24_volume_bracket: '24小时交易量',
  fee_24h: '24小时手续费收益',
  orders: '限价单',
  your_orders: '你的限价单',
  active: '活跃',
  history: '历史',
  you_sell: '卖出',
  you_buy: '买入',
  fee_tiers: '费率',
  created: '创建于',
  executed: '成交',
  actions: '动作',
  claimed_upper: '已认领',
  open_my_order: ' 等待交易',
  initial_order: '初始限价单',
  this_order_has_been_partially_filled: '该限价单已部分成交',
  filled_via_swap: '通过即时交易成交',
  state: '状态',
  partially: '部分',
  near_validation_error: '需要预留至少0.5NEAR来支付gas费用',
  near_min_validation_error: '需要预留至少0.2NEAR来支付gas费用',
  no_positons_in_this_pool_yet: '目前在该流动池没有份额',
  no_claimed_rewards_yet: '还没有领取的奖励',
  out_of: 'out of',
  fee_Tiers: '手续费的等级',
  no_pool: '没有池子',
  input_amount: '输入数量',
  update_range: '更新区间',
  not_enough_balance: '没有足够的余额',
  set_price_range: '设置价格区间',
  current_price: '当前价格',
  invalid_range_tip: '无效的选择范围。最小价格必须小于最大价格。',
  maket_price_outside_single_only_tip:
    '市场价格超出了价格范围。为相应的代币添加流动性。',
  min_price: '最小价格',
  max_price: '最大价格',
  min: '最小',
  out_of_range: '超出范围',
  in_range: '范围中',
  unclaimed_fees: '未领取的费',
  your_position_will_be: '你的位置将要',
  at_this_price: '在这个价格',
  price_range: '价格范围',
  positions: '持仓',
  position: '持仓',
  range: '范围',
  login_risk_tip:
    '通过勾选这个框并继续前进，您确认您完全了解使用{appName}的风险。',
  stable_pool: '稳定池',
  market_rate: '市场价',
  no_token_found: '没有找到代币',
  search_name_or_address: '搜索名字或粘贴地址...',
  token_address_invalid: '代币地址是无效的',
  price_impact_warning: '价格影响警告',
  confirm_order: '确认订单',
  you_Sell: '卖',
  to_Buy: '买',
  at_Price: '价格',
  insufficient_balance: '余额不足',
  limitTip: '您的价格将自动设置为最近的价格槽',
  v2_pools: 'DCL池',
  v2_your_pool_introduction: '您在DCL池中的流动性',
  v1_your_pool_introduction: '您在Classic池中的流动性',
  estimate_value: '预估价值',
  price: '价格',
  '@price': '@Price',
  trades: '最近成交',
  time: '时间',
  balances: '余额',
  asset: '资产',
  action: '操作',
  market: '市价单',
  Maker: '挂单',
  chart: '图表',
  refresh_data_to_continue: '请刷新页面以继续',
  refresh: '刷新',
  both: '所有',
  All: '全部',
  Filled: '已成交',
  assets: '资产',
  cancel_order: '取消订单',
  instrument: '币对',
  dex: 'Dex',
  limit_order_created: '限价单已创建',
  limit_order_filled: '限价单已成交',
  classic_pools: '经典池',
  active_orders: '未结订单',
  your_liquidity_usd_value: '你的流动性（美元价值）',
  usage: '用法',
  holding: '储备',
  your_lp_tokens_and_shares: '您的 LP 代币（股份）',
  swapped: '已交换',
  dcl_pool: 'DCL池',
  classic: '经典池',
  classic_farms: '经典农场',
  locked_in: '锁在',
  'deposit_near_tip_0.5': '0.5 NEAR留在钱包来支付gas费',
  trade: '交易',
  earn_2: '赚取',
  portfolio: '资产',
  more_2: '更多',
  liquidity_pools_2: '流动池',
  stable_pools: '稳定池',
  pool_detail: '流动池详情',
  new_contract_deploy_tip: '已部署新合约！请将您的流动性从旧合约中移除',
  remove_will_automatically_claim: '移除时将自动提取你还未认领的费用。',
  legacy_tip: '有未提取的LP代币和奖励在',
  legacy_farms: '遗产农场',
  all_farms: '全部农场',
  your_farms_2: '你的农场',
  dcl_farms: 'DCL农场',
  farm_type: '农场类型',
  farm_2: '农场',
  to_claim: '领取',
  liquidity_staked: '流动性质押',
  dcl_pool_detail: 'DCL池详情',
  reward_range: '奖励范围',
  reward_range_tip: '此范围内的农场奖励',
  ending_soon: '即将结束',
  farm_ended_tip: '这个农场已经结束了。',
  farm_will_ended_tip: '这个农场即将结束',
  new_farm: '新农场',
  is_coming: '即将到来',
  est_apr: 'Est. APR',
  farming: '农场质押中',
  unavailable: '不可用',
  hide: '隐藏',
  show: '展示',
  your: '你的',
  max_apr: '最大年化率',
  you_can_earn_tip: '你可以通过在农场中质押赚取奖励,预估APR是',
  you_can_earn_current_tip:
    '你当前质押的农场已经结束，新的农场即将来临，预估APR是',
  go_new_farm: '去到新农场',
  go_farm: '去农场',
  in_ended_farm: '在已结束农场',
  staked: '质押在',
  in_farm_3: '农场中',
  estimation: '估算值',
  this_staked_tip: '这笔NFT已经被质押',
  dcl_liquidity: 'DCL池流动性',
  classic_liquidity: '经典池流动性',
  will_appear_here_tip: '你的流动性仓位将展现在这里',
  dcl_will_appear_here_tip: '你的DCL流动性仓位将展现在这里',
  classic_will_appear_here_tip: '你的经典流动性仓位将展现在这里',
  price_range_overlap_ratio: '价格区间重叠率',
  real_time_executed_orders: '实时成交订单',
  real_time_executed_orders_tip:
    '当用户在限价单功能中下达一个高于市场价格的卖单或低于市场价格的买单时，{appName}会首先尝试执行swap-with-stop-point操作。如果执行完毕，订单数量仍有剩余，则会为剩余部分创建限价单。<br> 实时成交订单指使用限价单功能下单但通过swap完成的订单。在“历史”中，你可以查看自最早展示的限价单记录至今的实时成交订单。',
  swapped_history_order: '已成交',
  ledger_guide_tip_1: '为成功使用你的Ledger钱包交易，',
  ledger_guide_tip_2: '功能已自动开启。',
  ledger_guide_tip_3: '请注意',
  ledger_guide_tip_quote: '"',
  support_ledger_tip_new: '支持Ledger',
  ledger_guide_tip_4: '受ledger钱包限制，当前Swap功能提供的汇率',
  ledger_guide_tip_5: '可能不是最优价格',
  ledger_guide_tip_6: '.',
  your_trade_route: '你的交易路径',
  markets: '市场',
  exchanges: '交易所',
  output_est: '预计获得',
  new_swap_order_tip:
    '价格来自于{appName} AMM，仅供参考，不保证限价单能以某特定价格立即成交。',
  instants_swap: '即时成交',
  swappped: '已成交',
  claimed: '已领取',
  executing_capital: '执行中',
  trade_route: '交易路径',
  settings: '设置',
  no_trade_routes: '无交易路径',
  steps_in_the_route: '步',
  swap_chart_no_data: '目前该图表没有数据。',
  last_updated: '上次更新于',
  steps_in_the_route_zh: '交易路径中共',
  Burrow: 'Burrow',
  Supplied: '存款',
  APY: 'APY',
  top_bin_apr: 'Top Bin APR (24h)',
  size: '数量',
  deposit: '存入',
  Deposit: '存入',
  withdraw: '提取',
  Withdraw: '提取',
  swap: '兑换',
  Swap: '兑换',
  pool: '流动池',
  Pool: '流动池',
  pools: '流动池',
  Pools: '流动池',
  view_pools: '查看流动池',
  view_pool: '查看流动池',
  add_token: '添加代币',
  create_new_pool: '创建流动池',
  Create_New_Pool: '创建流动池',
  your_liquidity: '你的流动性',
  Your_Liquidity: '你的流动性',
  farms: '农场',
  Farms: '农场',
  docs: '文档',
  account: '账号',
  Discord: 'Discord',
  Telegram: 'Telegram',
  Twitter: 'Twitter',
  connect_to_near: '连接钱包',
  slippage: '滑点',
  minimum_received: '可收到的最低数额',
  swap_rate: '兑换汇率',
  pool_fee: '手续费',
  balance: '余额',
  from: '从',
  to: '到',
  submit: '提交',
  more_in_cn: '质押在',
  input_pool_id: '输入池子ID',
  watchlist: '收藏列表',
  tvl_total_value_locked: 'TVL（总锁定价值）',
  search_pool_by_token: '通过代币搜索流动池',
  dcl_pools: 'DCL池',
  your_liquidity_value: '您的流动性价值',
  dcl_pool_are_not_available_to_be_created_yet: 'DCL 池暂不支持创建',
  ledger_guide_tip_zh:
    '为保障交易完成，已为你打开support ledger功能。受ledger功能所限，当前价格可能不是最佳价格。',
};
export default Object.assign(zh_CN, zh_CN_in_risks_page);
